"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _gimweb_angular_service = require("../services/gimweb_angular_service.js");

var _gimweb_angular_service2 = _interopRequireDefault(_gimweb_angular_service);

var _location_service = require("../services/location_service.js");

var _location_service2 = _interopRequireDefault(_location_service);

var _meta_tag_service = require("../services/meta_tag_service.js");

var _meta_tag_service2 = _interopRequireDefault(_meta_tag_service);

var _translation_service = require("../services/translation_service.js");

var _translation_service2 = _interopRequireDefault(_translation_service);

var _constants = require("../../../packages/common-utilities/src/constants.js");

var _constants2 = _interopRequireDefault(_constants);

var _functional_utility = require("../../../packages/common-utilities/src/functional_utility.js");

var _functional_utility2 = _interopRequireDefault(_functional_utility);

var _spinner_utility = require("../../../packages/common-utilities/src/spinner_utility.js");

var _spinner_utility2 = _interopRequireDefault(_spinner_utility);

var _fund_commentary = require("./fund_commentary.js");

var _fund_commentary2 = _interopRequireDefault(_fund_commentary);

var _fund_esg_information = require("./fund_esg_information");

var _fund_esg_information2 = _interopRequireDefault(_fund_esg_information);

var _fund_dividends_capital_gains = require("./fund_dividends_capital_gains.js");

var _fund_dividends_capital_gains2 = _interopRequireDefault(_fund_dividends_capital_gains);

var _fund_documents = require("./fund_documents.js");

var _fund_documents2 = _interopRequireDefault(_fund_documents);

var _fund_overview = require("./fund_overview.js");

var _fund_overview2 = _interopRequireDefault(_fund_overview);

var _fund_performance_fees = require("./fund_performance_fees.js");

var _fund_performance_fees2 = _interopRequireDefault(_fund_performance_fees);

var _fund_historical_prices = require("./fund_historical_prices.js");

var _fund_historical_prices2 = _interopRequireDefault(_fund_historical_prices);

var _fund_portfolio = require("./fund_portfolio.js");

var _fund_portfolio2 = _interopRequireDefault(_fund_portfolio);

var _fund_definitons = require("./fund_definitons");

var _fund_definitons2 = _interopRequireDefault(_fund_definitons);

var _tooltip_component = require("./global_components/tooltip_component.js");

var _tooltip_component2 = _interopRequireDefault(_tooltip_component);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _ramda = require("ramda");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require("react-waypoint");

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _reactCollapsible = require("react-collapsible");

var _reactCollapsible2 = _interopRequireDefault(_reactCollapsible);

var _funds_service = require("../services/funds_service");

var _funds_service2 = _interopRequireDefault(_funds_service);

var _reactIdleTimer = require("react-idle-timer");

var _reactIdleTimer2 = _interopRequireDefault(_reactIdleTimer);

var _functional_utility3 = require("../../../packages/common-utilities/src/functional_utility");

var _string_utility = require("../../../packages/common-utilities/src/string_utility.js");

var _string_utility2 = _interopRequireDefault(_string_utility);

var _cms_utility = require("../../../packages/common-utilities/src/cms_utility");

var _reactIntl = require("react-intl");

var _pdp_summary = require("./pdp_summary");

var _pdp_summary2 = _interopRequireDefault(_pdp_summary);

var _pdp_bottom_disclosure = require("./pdp_bottom_disclosure");

var _pdp_bottom_disclosure2 = _interopRequireDefault(_pdp_bottom_disclosure);

var _collection_utility = require("common-utilities/src/collection_utility");

var _tracking_utility = require("common-utilities/src/tracking_utility");

var _distributor_table_component = require("./distributor_table_component");

var _distributor_table_component2 = _interopRequireDefault(_distributor_table_component);

var _fund_security_lending = require("./fund_security_lending");

var _fund_security_lending2 = _interopRequireDefault(_fund_security_lending);

var _functional_utility4 = require("common-utilities/src/functional_utility");

var _functional_utility5 = _interopRequireDefault(_functional_utility4);

var _accessibility_utility = require("../../../packages/common-utilities/src/accessibility_utility");

var _accessibility_utility2 = _interopRequireDefault(_accessibility_utility);

var _slide_drawer = require("./slide_drawer/slide_drawer");

var _slide_drawer2 = _interopRequireDefault(_slide_drawer);

var _modal = require("./global_components/modal");

var _modal2 = _interopRequireDefault(_modal);

var _state_service = require("../services/state_service");

var _state_service2 = _interopRequireDefault(_state_service);

var _fund_pcf = require("./fund_pcf");

var _fund_pcf2 = _interopRequireDefault(_fund_pcf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global fundsMarketingConfiguration*/


var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var getDefaultTab = function getDefaultTab(role) {
  return _constants2.default.getSixcirclesRole() === role || _constants2.default.getPriipsRole() === role ? "performance" : "overview";
};

var ProductDetailApp = function (_React$Component) {
  _inherits(ProductDetailApp, _React$Component);

  function ProductDetailApp(props) {
    _classCallCheck(this, ProductDetailApp);

    var _this = _possibleConstructorReturn(this, (ProductDetailApp.__proto__ || Object.getPrototypeOf(ProductDetailApp)).call(this, props));

    _this.renderModal = function () {
      if ((0, _functional_utility3.doesVisibleDataPointContains)('SHOW_DOCUMENT_TAB_SUBSCRIPTION_BUTTON', _this.props)) {
        var modalConfig = _this.state.modalConfig || {};
        return _react2.default.createElement(
          "div",
          { "data-testid": modalConfig.modalType + "-modal" },
          _react2.default.createElement(_modal2.default, { display: modalConfig.display,
            type: modalConfig.modalType,
            modalContent: modalConfig.modalContent,
            hideCloseModalButton: true,
            closeModal: _this.closeModal,
            gaiaRedirectUrl: _this.props.gaiaRedirectUrl
          })
        );
      }
    };

    _location_service2.default.setTargetWindowObject(props.window);
    _meta_tag_service2.default.setTargetWindowObject(props.window);
    _translation_service2.default.setTargetLanguage(props.language);
    _gimweb_angular_service2.default.setAngularObject(props.angular);

    _this.state = {
      currentTab: _this.getTargetTabName(_location_service2.default.getUrlHashParameter()),
      scrolledTab: null,
      breakpoint: 4,
      historicalData: [],
      hasPortfolioData: true,
      autocompleteFundData: [],
      printMode: false,
      additionalRatings: null,
      enableScrollAnimation: false,
      showSlideDrawer: false,
      dynamicContentStart: null
    };

    if ((0, _functional_utility3.doesVisibleDataPointContains)('SHOW_DOCUMENT_TAB_SUBSCRIPTION_BUTTON', _this.props)) {
      _this.state = _extends({}, _this.state, {
        modalConfig: {
          display: 'none',
          modalType: 'loading',
          modalContent: ''
        }
      });
      _state_service2.default.getModalState$().subscribe(function () {
        var modalState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (!modalState.modalConfig) {
          return;
        }
        _this.setState({ modalConfig: modalState.modalConfig });
      });
    }

    _this.globalTooltipRef = _react2.default.createRef();
    _this.summaryHeaderFundDetailsRef = _react2.default.createRef();

    _this.updateTabState = _this.updateTabState.bind(_this);
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    _this.getHistoricalData = _this.getHistoricalData.bind(_this);
    _this.setStateOfHistoricalData = _this.setStateOfHistoricalData.bind(_this);
    _this.getAutoCompleteFundData = _this.getAutoCompleteFundData.bind(_this);
    _this.fundOverviewPane = _this.fundOverviewPane.bind(_this);
    _this.fundPerformanceFeesPane = _this.fundPerformanceFeesPane.bind(_this);
    _this.fundHistoricalPricePane = _this.fundHistoricalPricePane.bind(_this);
    _this.fundPortfolioPane = _this.fundPortfolioPane.bind(_this);
    _this.fundSecurityLendingPane = _this.fundSecurityLendingPane.bind(_this);
    _this.fundDividendsCapitalGainsPane = _this.fundDividendsCapitalGainsPane.bind(_this);
    _this.fundDistributorPane = _this.fundDistributorPane.bind(_this);
    _this.fundCommentaryPane = _this.fundCommentaryPane.bind(_this);
    _this.fundPCFPane = _this.fundPCFPane.bind(_this);
    _this.fundESGInformationPane = _this.fundESGInformationPane.bind(_this);
    _this.fundDocumentsPane = _this.fundDocumentsPane.bind(_this);
    _this.fundDefinitionsPane = _this.fundDefinitionsPane.bind(_this);
    _this.renderCollapsibleComponent = _this.renderCollapsibleComponent.bind(_this);
    _this.checkEmptyPortfolioData = _this.checkEmptyPortfolioData.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.scrollToTopOfPage = _this.scrollToTopOfPage.bind(_this);
    _this.getTargetTabName = _this.getTargetTabName.bind(_this);
    _this.setFundState = _this.setFundState.bind(_this);
    _this.beforePrint = _this.beforePrint.bind(_this);
    _this.afterPrint = _this.afterPrint.bind(_this);
    _this.mediaQueryHandler = _this.mediaQueryHandler.bind(_this);
    _this.additionalRatingsHandler = _this.additionalRatingsHandler.bind(_this);
    _this.activeCardScrollHandler = _this.activeCardScrollHandler.bind(_this);
    _this.onScrollAnimationComplete = _this.onScrollAnimationComplete.bind(_this);
    _this.openSlideDrawer = _this.openSlideDrawer.bind(_this);
    _this.handleOnIdle = _this.handleOnIdle.bind(_this);
    _this.handleOnAction = _this.handleOnAction.bind(_this);
    _this.trackDynamicContentDrawer = _this.trackDynamicContentDrawer.bind(_this);
    _this.idleTimer = _react2.default.createRef();
    fundsMarketingConfiguration.hashChangeHandler = _this.changeTab.bind(_this);
    props.window.onbeforeprint = _this.beforePrint;
    props.window.onafterprint = _this.afterPrint;
    return _this;
  }

  _createClass(ProductDetailApp, [{
    key: "beforePrint",
    value: function beforePrint() {
      this.setState({ printMode: true });
    }
  }, {
    key: "afterPrint",
    value: function afterPrint() {
      this.setState({ printMode: false });
    }
  }, {
    key: "getTargetTabName",
    value: function getTargetTabName(hashParameter) {
      if (hashParameter === "" || hashParameter.indexOf("Card") > 0) {
        return getDefaultTab(this.props.role);
      } else {
        return hashParameter;
      }
    }
  }, {
    key: "getHistoricalData",
    value: function getHistoricalData() {
      var _this2 = this;

      var historicalDataPromise = _funds_service2.default.getHistoricalData(this.props.userLoggedIn, this.props.cusip, this.props.country, this.props.role, this.props.language, this.props.gaiaRedirectUrl + "/historicalData");
      historicalDataPromise.then(function (historicalData) {
        _this2.setStateOfHistoricalData(historicalData);
      });
    }
  }, {
    key: "isFlatMode",
    value: function isFlatMode() {
      return this.state.breakpoint > 3 && (0, _functional_utility3.doesVisibleDataPointContains)("FLAT_MODE", this.props);
    }
  }, {
    key: "setStateOfHistoricalData",
    value: function setStateOfHistoricalData(historicalData) {
      this.setState({ historicalData: historicalData });
    }
  }, {
    key: "mediaQueryHandler",
    value: function mediaQueryHandler(mql) {
      if (mql.matches) {
        this.beforePrint();
      } else {
        this.afterPrint();
      }
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.getHistoricalData();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var role = this.props.role;


      this.updateMetaTags();
      this.updateFundManagerImagesState();
      this.updateInvestmentAdvisorImagesState();
      this.updateWindowDimensions();
      this.props.window.addEventListener('resize', this.updateWindowDimensions);

      if (!(0, _ramda.includes)(role, _constants.EXCLUDED_ROLES_PDP_STICKY_HEADER)) {
        this.props.window.addEventListener("scroll", this.handleScroll);
      }

      _collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesJTFConstants(), role) ? null : this.getAutoCompleteFundData();
      _spinner_utility2.default.stopSpinner();

      if (this.props.window.matchMedia) {
        this.props.window.matchMedia('print').addListener(this.mediaQueryHandler);
      }

      if (this.props.printModeForFeatureTest) {
        this.beforePrint();
      }
    }
  }, {
    key: "getAutoCompleteFundData",
    value: function getAutoCompleteFundData() {
      var _this3 = this;

      var autocompleteServiceUrl = this.props.gaiaRedirectUrl + "/autocomplete?country=" + this.props.country + "&role=" + this.props.role + "&language=" + this.props.language + "&userLoggedIn=" + this.props.userLoggedIn + "&version=8.8_1746361865";
      _jquery2.default.get("" + autocompleteServiceUrl).then(function (data) {
        _this3.setState({ autocompleteFundData: data, errorMsg: "" });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var role = this.props.role;

      this.props.window.removeEventListener('resize', this.updateWindowDimensions);

      if (!(0, _ramda.includes)(role, _constants.EXCLUDED_ROLES_PDP_STICKY_HEADER)) {
        this.props.window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var hasPortfolioData = this.state.hasPortfolioData;

      if (hasPortfolioData) {
        this.checkEmptyPortfolioData();
      }

      if (this.isFlatMode() && !(0, _ramda.isNil)(this.state.currentTab) && (0, _ramda.isNil)(this.state.scrolledTab)) {

        if (this.state.currentTab === "overview") {
          this.scrollToTopOfPage();
        } else {
          var stickyHeaderHeight = (0, _ramda.isNil)(this.refs.summary.stickyHeaderRef) || this.refs.summary.stickyHeaderRef.offsetHeight === 0 ? 233 : this.refs.summary.stickyHeaderRef.offsetHeight;
          var elementToScrollTo = document.getElementById(this.state.currentTab);

          if (!(0, _ramda.isNil)(elementToScrollTo)) {
            var topValue = document.getElementById(this.state.currentTab).offsetTop - stickyHeaderHeight - 12;

            (0, _jquery2.default)('html, body').animate({
              scrollTop: topValue,
              queue: false
            }, 500, this.onScrollAnimationComplete);
          }
        }
      }
    }
  }, {
    key: "onScrollAnimationComplete",
    value: function onScrollAnimationComplete() {
      if (this.isFlatMode() && this.state.enableScrollAnimation) {
        this.setState({ enableScrollAnimation: false });
      }
    }
  }, {
    key: "getFundNameElement",
    value: function getFundNameElement() {
      return document.getElementById("fund-name");
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      var breakpoint = this.state.breakpoint;


      if ((0, _ramda.or)(breakpoint < 4, (0, _ramda.isNil)(this.contentWrapper))) {
        return false;
      }

      var stickyHeaderHeight = (0, _ramda.isNil)(this.refs.summary.stickyHeaderRef) || this.refs.summary.stickyHeaderRef.offsetHeight === 0 ? 150 : this.refs.summary.stickyHeaderRef.offsetHeight;
      var distanceFromTopMenu = this.contentWrapper.getBoundingClientRect().top;

      if (!(0, _ramda.isNil)(this.globalTooltipRef.current)) {
        this.globalTooltipRef.current.closeTooltip();
      }

      if (distanceFromTopMenu <= stickyHeaderHeight) {
        if (!(0, _ramda.isNil)(this.refs.summary.stickyHeaderRef) && this.refs.summary.stickyHeaderRef.className !== 'sticky-header print-disable-sticky') {
          this.refs.summary.stickyHeaderRef.className = 'sticky-header print-disable-sticky';
        }
      } else if (distanceFromTopMenu > stickyHeaderHeight && !(0, _ramda.isNil)(this.refs.summary.stickyHeaderRef) && this.refs.summary.stickyHeaderRef.className !== 'hide print-disable-sticky') {
        this.refs.summary.stickyHeaderRef.className = 'hide print-disable-sticky';
      }

      var triggerForHidingStickyHeader = this.getBottomPositionOfActivePane() - stickyHeaderHeight;

      if (triggerForHidingStickyHeader <= 0) {
        this.refs.summary.stickyHeaderRef.setAttribute("style", "top: " + stickyHeaderHeight * -1 + "px;");
      } else if (this.refs.summary.stickyHeaderRef) {
        this.refs.summary.stickyHeaderRef.setAttribute("style", "top: 0px;");
      }
    }
  }, {
    key: "updateWindowDimensions",
    value: function updateWindowDimensions() {
      var windowWidth = (0, _ramda.pathOr)(this.props.window.innerWidth, ["window", "document", "documentElement", "clientWidth"], this.props);

      this.setState({ breakpoint: _constants2.default.getBreakpointForWidth(windowWidth) });

      if (this.state.breakpoint <= 3 && !(0, _ramda.isNil)(this.refs.summary.stickyHeaderRef)) {
        this.refs.summary.stickyHeaderRef.className = 'hide print-disable-sticky';
      }

      if ((0, _ramda.isNil)(this.state.currentTab)) {
        this.setState({ currentTab: getDefaultTab(this.props.role) });
      }
    }
  }, {
    key: "updateMetaTags",
    value: function updateMetaTags() {
      var fundName = this.props.fund.name + ' - ' + this.props.fund.shareClass.categoryCode;
      var meta = {
        title: fundName + ' ',
        meta: {
          name: {
            assetID: this.props.cusip,
            assetType: 'Product',
            keywords: this.props.cusip + ',' + this.props.fund.shareClass.ticker + ',' + fundName
          }
        }
      };
      _meta_tag_service2.default.updateMetaTags(meta);
    }
  }, {
    key: "changeTab",
    value: function changeTab() {
      var tabName = _location_service2.default.getUrlHashParameter();
      if (tabName === "") {
        tabName = getDefaultTab(this.props.role);
      }

      this.setState({
        currentTab: tabName
      });
    }
  }, {
    key: "getFundManagerImageServiceURL",
    value: function getFundManagerImageServiceURL() {
      var fundManagerImageServiceURL = this.props.gaiaRedirectUrl + '/manager-images?';
      mapIndexed(function (fundManager, i) {
        var separator = "%20";
        if (i === 0) {
          fundManagerImageServiceURL = fundManagerImageServiceURL + 'names=' + fundManager.firstName + separator + fundManager.lastName;
        } else {
          fundManagerImageServiceURL = fundManagerImageServiceURL + '&names=' + fundManager.firstName + separator + fundManager.lastName;
        }
      }, this.props.fund.fundManagers);
      fundManagerImageServiceURL = fundManagerImageServiceURL + '&country=' + this.props.country + '&role=' + this.props.role + '&language=' + this.props.language + '&version=8.8_1746361865';
      return fundManagerImageServiceURL;
    }
  }, {
    key: "updateFundManagerImagesState",
    value: function updateFundManagerImagesState() {
      var _this4 = this;

      var fund = this.props.fund;
      if (!(0, _ramda.isNil)(this.props.fund.fundManagers) && this.props.fund.fundManagers.length !== 0 && this.props.fund.fundTypeCode !== '529 Plans') {
        var fundManagers = fund.fundManagers;
        if (!(0, _ramda.isNil)(this.props.content) && !(0, _ramda.isNil)(this.props.content.fundManagers) && this.props.content.fundManagers.length !== 0) {
          fund.fundManagers = this.mergeFundManagersContentData(fundManagers, this.props.content.fundManagers);
          this.setFundState(fund);
        } else {
          _jquery2.default.get("" + this.getFundManagerImageServiceURL()).then(function (data) {
            fund.fundManagers = _this4.mergeFundManagersResponseData(fundManagers, data);
            _this4.setFundState(fund);
          });
        }
      }
    }
  }, {
    key: "updateInvestmentAdvisorImagesState",
    value: function updateInvestmentAdvisorImagesState() {
      var _this5 = this;

      var fund = this.props.fund;
      if (!(0, _ramda.isNil)(this.props.fund.investmentAdvisors) && this.props.fund.investmentAdvisors.length !== 0 && this.props.fund.fundTypeCode !== '529 Plans') {
        var investmentAdvisors = fund.investmentAdvisors;
        if (!(0, _ramda.isNil)(this.props.content) && !(0, _ramda.isNil)(this.props.content.fundManagers) && this.props.content.fundManagers.length !== 0) {
          fund.investmentAdvisors = this.mergeFundManagersContentData(investmentAdvisors, this.props.content.fundManagers);
          this.setFundState(fund);
        } else {
          _jquery2.default.get("" + this.getFundManagerImageServiceURL()).then(function (data) {
            fund.investmentAdvisors = _this5.mergeFundManagersResponseData(investmentAdvisors, data);
            _this5.setFundState(fund);
          });
        }
      }
    }
  }, {
    key: "setFundState",
    value: function setFundState(fund) {
      this.setState({ fund: fund });
    }
  }, {
    key: "mergeFundManagersContentData",
    value: function mergeFundManagersContentData(edpiDataFundManagers, contentFundManagers) {
      if ((0, _functional_utility3.isNilOrEmpty)(edpiDataFundManagers)) {
        return edpiDataFundManagers;
      }
      return edpiDataFundManagers.map(function (fundManager) {
        if (contentFundManagers.hasOwnProperty(fundManager.identifier)) {
          var value = contentFundManagers[fundManager.identifier];
          return Object.assign(fundManager, value);
        }
        return fundManager;
      });
    }
  }, {
    key: "mergeFundManagersResponseData",
    value: function mergeFundManagersResponseData(edpiDataFundManagers, contentFundManagers) {
      (0, _ramda.map)(function (fundManager) {
        (0, _ramda.map)(function (fundManagerWithImageURL) {
          if (fundManager.firstName + " " + fundManager.lastName === fundManagerWithImageURL.fullName) {
            fundManager.imageURL = fundManagerWithImageURL.imageURL;
            fundManager.profileURL = fundManagerWithImageURL.profileURL;
          }
        }, contentFundManagers);
      }, edpiDataFundManagers);
      return edpiDataFundManagers;
    }
  }, {
    key: "missingRequiredProps",
    value: function missingRequiredProps() {
      return (0, _ramda.isNil)(this.props.cusip) || (0, _ramda.isNil)(this.props.country) || (0, _ramda.isNil)(this.props.fund);
    }
  }, {
    key: "additionalRatingsHandler",
    value: function additionalRatingsHandler(val) {
      if (!(0, _ramda.isNil)(val)) {
        this.setState({ additionalRatings: val });
      }
    }
  }, {
    key: "updateTabState",
    value: function updateTabState(e) {
      e.preventDefault();
      if (this.isFlatMode()) {
        this.setState({ scrolledTab: null });
      }
      var newState = e.target.getAttribute('data-tab-name');

      if ((0, _ramda.isNil)(newState)) {
        newState = e.target.parentElement.getAttribute('data-tab-name');
      }

      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": 'pdp',
        "eventAction": 'section nav',
        "eventLabel": newState
      });

      if (typeof newState === "string") {
        fundsMarketingConfiguration.inAppClick = true;
        _location_service2.default.setUrlHashParameter(newState);
      }

      if ((0, _ramda.isNil)(newState) || this.state.currentTab === newState) {
        return false;
      }

      if (!this.isFlatMode()) {
        this.scrollToTopOfPage();
      }

      this.setState({ currentTab: newState, enableScrollAnimation: true });
      this.globalTooltipRef.current.closeTooltip();
    }
  }, {
    key: "scrollToTopOfPage",
    value: function scrollToTopOfPage() {
      if (this.refs.summary.stickyHeaderRef.className === 'hide print-disable-sticky') {
        return false;
      }

      (0, _jquery2.default)('html, body').animate({
        scrollTop: 0,
        queue: false
      }, 500, this.onScrollAnimationComplete);
    }
  }, {
    key: "scrollToTabPosition",
    value: function scrollToTabPosition(accordionPosition) {
      var tab = this[accordionPosition];
      if (tab.length < 1 || !tab.offsetTop) {
        return null;
      }

      var topValue = tab.offsetTop;
      this.props.window.scrollTo(0, topValue);
    }
  }, {
    key: "activeCardScrollHandler",
    value: function activeCardScrollHandler(newActiveTab) {
      if (!this.state.enableScrollAnimation) {
        this.setState({ scrolledTab: newActiveTab });
      }
    }
  }, {
    key: "renderflatModeSectionHeader",
    value: function renderflatModeSectionHeader(label, tabId) {
      if (!this.isFlatMode()) {
        return null;
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_reactWaypoint2.default, { onEnter: this.activeCardScrollHandler.bind(this, tabId) }),
        _react2.default.createElement("div", { className: "portfolio-flat-card-divider border-vertical-1 border-peacock-blue" }),
        _react2.default.createElement(
          "h2",
          { id: "flat-mode-section-title", "data-testid": "flat-mode-section-title-" + tabId,
            className: "font-regular font-black-variant sub-header-2 margin-top-30 margin-bottom-30" },
          label
        )
      );
    }
  }, {
    key: "fundOverviewPane",
    value: function fundOverviewPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "overview-tab",
          className: "tab-pane row " + (this.state.currentTab === "overview" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "overview-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "overview" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("OVERVIEW", "pdp-overview-tab-flat-label"), "overview"),
        _react2.default.createElement(_fund_overview2.default, {
          fund: this.props.fund,
          fundDistribution: this.state.historicalData.fundDistribution,
          historicalData: this.state.historicalData,
          messages: this.props.messages,
          userLoggedIn: this.props.userLoggedIn,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          breakpoint: this.state.breakpoint,
          basePath: this.props.basePath,
          window: this.props.window,
          tooltip: this.globalTooltipRef.current,
          active: this.state.currentTab,
          country: this.props.country,
          language: this.props.language,
          role: this.props.role,
          content: this.props.content,
          additionalRatings: this.state.breakpoint >= 3 ? this.state.additionalRatings : this.props.fund.fundPerformanceRatings,
          cusip: this.props.cusip,
          parent: this.props.parent,
          isAEM: (0, _cms_utility.isAEM)(this.props)
        })
      );
    }
  }, {
    key: "fundPerformanceFeesPane",
    value: function fundPerformanceFeesPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "performance-tab",
          className: "tab-pane row " + (this.state.currentTab === "performance" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "performance-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "performance" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("PERFORMANCE & FEES", "pdp-performance-tab-flat-label", { role: this.props.role }), "performance"),
        _react2.default.createElement(_fund_performance_fees2.default, {
          fund: this.props.fund,
          active: this.state.currentTab,
          breakpoint: this.state.breakpoint,
          cusip: this.props.cusip,
          country: this.props.country,
          content: this.props.content,
          role: this.props.role,
          historicalData: this.state.historicalData,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          disclosures: this.props.fund.disclosures,
          tooltip: this.globalTooltipRef.current,
          window: this.props.window,
          appType: this.props.appType,
          isFlatMode: this.isFlatMode(),
          intl: this.props.intl,
          annualDividendPerShare: this.props.fund.annualDividendPerShare
        })
      );
    }
  }, {
    key: "fundHistoricalPricePane",
    value: function fundHistoricalPricePane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "historical-price-tab",
          className: "tab-pane row " + (this.state.currentTab === "historical-price" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "historical-price-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "historical-price" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("HISTORICAL PRICE", "pdp-historical-price-tab-flat-label"), "historical-price"),
        _react2.default.createElement(_fund_historical_prices2.default, {
          active: this.state.currentTab,
          breakpoint: this.state.breakpoint,
          cusip: this.props.cusip,
          country: this.props.country,
          language: this.props.language,
          role: this.props.role,
          historicalData: this.state.historicalData,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          fund: this.props.fund,
          window: this.props.window,
          tooltip: this.globalTooltipRef.current,
          isFlatMode: this.isFlatMode(),
          intl: this.props.intl
        })
      );
    }
  }, {
    key: "fundPortfolioPane",
    value: function fundPortfolioPane(testLabel) {
      if (this.state.currentTab !== "portfolio" && !this.state.printMode && !this.isFlatMode()) {
        return null;
      }
      return _react2.default.createElement(
        "div",
        { key: "portfolio-tab",
          className: "tab-pane row " + (this.state.currentTab === "portfolio" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "portfolio-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "portfolio" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("PORTFOLIO", "pdp-porfolio-price-tab-flat-label"), "portfolio"),
        _react2.default.createElement(_fund_portfolio2.default, {
          fund: this.props.fund,
          country: this.props.country,
          language: this.props.language,
          cusip: this.props.cusip,
          role: this.props.role,
          historicalData: this.state.historicalData,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          scrollPosition: this.state.scrollTop,
          active: this.state.currentTab,
          window: this.props.window,
          breakpoint: this.state.breakpoint,
          tooltip: this.globalTooltipRef.current,
          isFlatMode: this.isFlatMode(),
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          scrolledTab: this.state.scrolledTab,
          content: this.props.content,
          isAEM: (0, _cms_utility.isAEM)(this.props),
          intl: this.props.intl
        })
      );
    }
  }, {
    key: "fundSecurityLendingPane",
    value: function fundSecurityLendingPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "securities-lending-tab",
          className: "tab-pane row " + (this.state.currentTab === "securities-lending" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "securities-lending-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "securities-lending" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("SECURITIES LENDING", "pdp-securities-lending-tab-label"), "securities-lending"),
        _react2.default.createElement(_fund_security_lending2.default, {
          fund: this.props.fund,
          country: this.props.country,
          language: this.props.language,
          cusip: this.props.cusip,
          role: this.props.role,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          scrollPosition: this.state.scrollTop,
          active: this.state.currentTab,
          window: this.props.window,
          breakpoint: this.state.breakpoint,
          tooltip: this.globalTooltipRef.current,
          isFlatMode: this.isFlatMode(),
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          content: this.props.content
        })
      );
    }
  }, {
    key: "fundDividendsCapitalGainsPane",
    value: function fundDividendsCapitalGainsPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "dividends-tab",
          className: "tab-pane row " + (this.state.currentTab === "dividends" || this.state.currentTab === "distribution" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "dividends-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "dividends" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("DIVIDENDS & CAPITAL GAINS", "pdp-dividends-tab-flat-label", { role: this.props.role }), "dividends"),
        _react2.default.createElement(_fund_dividends_capital_gains2.default, {
          active: this.state.currentTab,
          disclosures: this.props.fund.disclosures,
          dividendsFrequencyLabel: _constants2.default.getDividendsFrequencyLabel(this.props.fund.dividendsFrequency),
          distributionFrequencyLabel: this.props.fund.shareClass.distributionFrequency,
          dividendData: this.state.historicalData.dividendsDistributionHistoryList,
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          formattingRules: this.props.fund.visibleData.formattingRules,
          visibleCards: this.props.fund.visibleData.visibleCards,
          breakpoint: this.state.breakpoint,
          currencyCode: this.props.fund.shareClass.currencyCode,
          role: this.props.role,
          capitalGainsData: this.state.historicalData.capitalGainsDistributionHistoryList,
          shareClass: this.props.fund.shareClass,
          fundTypeCode: this.props.fund.fundTypeCode,
          legalStructureCode: this.props.fund.legalStructureCode,
          fundDistribution: this.state.historicalData.fundDistribution,
          country: this.props.country,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          cusip: this.props.cusip,
          annualDividendPerShare: this.props.fund.annualDividendPerShare,
          content: this.props.content,
          isShareclassMoreThanSixMonthsOld: this.props.fund.isShareclassMoreThanSixMonthsOld,
          distributingCode: this.props.fund.shareClass.distributingCode,
          distributionFrequency: this.props.fund.shareClass.distributionFrequency,
          historicalBiMonthlyBonusList: this.state.historicalData.historicalBiMonthlyBonusList,
          tooltip: this.globalTooltipRef.current,
          intl: this.props.intl,
          numberFormat: this.props.fund.numberFormat
        })
      );
    }
  }, {
    key: "fundDistributorPane",
    value: function fundDistributorPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "distributor-tab",
          className: "tab-pane row " + (this.state.currentTab === "distributor" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "distributor-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "distributor" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("DISTRIBUTOR", "pdp-distributor-tab-flat-label", { role: this.props.role }), "distributor"),
        _react2.default.createElement(_distributor_table_component2.default, { data: this.props.fund.distributor,
          breakpoint: this.state.breakpoint,
          disclosure: this.props.fund.disclosures.pdpCardDistributor,
          headerTitleKey: "pdp-overview-distributor-header-label",
          headerTitleId: "fund-distributor-title" })
      );
    }
  }, {
    key: "fundPCFPane",
    value: function fundPCFPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "pcf-tab",
          className: "tab-pane row " + (this.state.currentTab === "pcf" ? "active" : "") + " print-hide",
          role: "tabpanel", "aria-labelledby": "pcf-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "pcf" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("申購買回清單", "pdp-pcf-tab-flat-label"), "pcf"),
        _react2.default.createElement(_fund_pcf2.default, {
          country: this.props.country,
          cusip: this.props.cusip,
          role: this.props.role,
          breakpoint: this.state.breakpoint,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          fund: this.props.fund,
          historicalData: this.state.historicalData,
          tooltip: this.globalTooltipRef.current,
          language: this.props.language,
          active: this.state.currentTab
        })
      );
    }
  }, {
    key: "fundCommentaryPane",
    value: function fundCommentaryPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "commentary-tab",
          className: "tab-pane row " + (this.state.currentTab === "commentary" ? "active" : "") + " print-hide",
          role: "tabpanel", "aria-labelledby": "commentary-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "commentary" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("COMMENTARY", "pdp-commentary-tab-flat-label"), "commentary"),
        _react2.default.createElement(_fund_commentary2.default, {
          fund: this.props.fund,
          historicalData: this.state.historicalData,
          breakpoint: this.state.breakpoint,
          country: this.props.country
        })
      );
    }
  }, {
    key: "fundESGInformationPane",
    value: function fundESGInformationPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "esg-information-tab",
          className: "tab-pane row " + (this.state.currentTab === "esg-information" ? "active" : "") + " print-hide",
          role: "tabpanel", "aria-labelledby": "esg-information-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "esg-information" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("ESG INFORMATION", "pdp-esg-information-tab-flat-label"), "esg-information"),
        _react2.default.createElement(_fund_esg_information2.default, {
          country: this.props.country,
          language: this.props.language,
          role: this.props.role,
          cusip: this.props.cusip,
          breakpoint: this.state.breakpoint,
          content: this.props.content,
          userLoggedIn: this.props.userLoggedIn,
          basePath: this.props.basePath,
          window: this.props.window,
          isAEM: (0, _cms_utility.isAEM)(this.props),
          intl: this.props.intl,
          fund: this.props.fund,
          tooltip: this.globalTooltipRef.current
        })
      );
    }
  }, {
    key: "fundDocumentsPane",
    value: function fundDocumentsPane(testLabel) {
      var esgData = this.props.fund.esgData || {};
      return _react2.default.createElement(
        "div",
        { key: "documents-tab",
          className: "tab-pane row " + (this.state.currentTab === "documents" ? "active" : "") + " print-display",
          role: "tabpanel", "aria-labelledby": "esg-documents-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "documents" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("DOCUMENTS", "pdp-documents-tab-flat-label"), "documents"),
        _react2.default.createElement(_fund_documents2.default, {
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          formattingRules: this.props.fund.visibleData.formattingRules,
          fundTypeCode: this.props.fund.fundTypeCode,
          fundDocuments: this.props.fund.fundDocuments,
          cusip: this.props.cusip,
          jpETFCusip: this.props.fund.shareClass.cusip,
          userLoggedIn: this.props.userLoggedIn,
          breakpoint: this.state.breakpoint,
          role: this.props.role,
          country: this.props.country,
          basePath: this.props.basePath,
          window: this.props.window,
          cmsHost: this.props.fund.cmsHost,
          cmsShare: this.props.fund.cmsShare,
          formNMFPLink: this.props.fund.formNMFPLink,
          fundName: this.props.fund.name,
          hasFundDistribution: this.hasFundDistribution(),
          legalStructureCode: this.props.fund.legalStructureCode,
          disclosure: this.props.fund.disclosures,
          content: this.props.content,
          isShareclassMoreThanSixMonthsOld: this.props.fund.isShareclassMoreThanSixMonthsOld,
          isAEM: (0, _cms_utility.isAEM)(this.props),
          language: this.props.language,
          gaiaRedirectUrl: this.props.gaiaRedirectUrl,
          factsheetUrl: this.props.fund.factsheetUrl,
          kiidUrl: this.props.fund.kiidUrl,
          esgIntegrationFlag: esgData.esgIntegrationFlag,
          tooltip: this.globalTooltipRef.current
        })
      );
    }
  }, {
    key: "fundDefinitionsPane",
    value: function fundDefinitionsPane(testLabel) {
      return _react2.default.createElement(
        "div",
        { key: "definitions-tab",
          className: "tab-pane row " + (this.state.currentTab === "definitions" ? "active" : "") + " print-hide",
          role: "tabpanel", "aria-labelledby": "definitions-tab", tabIndex: "0", "data-test-pane": "" + testLabel, id: "definitions" },
        this.renderflatModeSectionHeader(_string_utility2.default.renderFormattedLabel("DEFINITIONS", "pdp-definitions-tab-flat-label"), "definitions"),
        _react2.default.createElement(_fund_definitons2.default, null)
      );
    }
  }, {
    key: "hasFundDistribution",
    value: function hasFundDistribution() {
      return !(0, _ramda.isNil)(this.state.historicalData.fundDistribution) && (0, _ramda.length)(this.state.historicalData.fundDistribution) > 0;
    }
  }, {
    key: "renderCollapsibleComponent",
    value: function renderCollapsibleComponent(tab, label, pane) {
      var _this6 = this;

      var collapsibleStyles = "sub-header-3 position-relative-important padding-important-17 width-100pct text-left";
      this[tab] = _react2.default.createRef();
      var propObject = {
        'aria-expanded': this.state.currentTab === tab,
        'id': tab
      };

      var containerElemProps = {
        'ref': this[tab],
        'onKeyDown': function onKeyDown(event) {
          return _accessibility_utility2.default.handleAccordionEvents(_this6, event, "#" + tab + "_accordion", tab, 'overview', _this6.handleTriggerClick.bind(_this6, tab));
        }
      };
      return _react2.default.createElement(
        _reactCollapsible2.default,
        {
          containerElementProps: containerElemProps,
          triggerElementProps: propObject,
          accordionPosition: tab,
          triggerClassName: collapsibleStyles,
          triggerOpenedClassName: collapsibleStyles,
          trigger: label,
          triggerTagName: "button",
          className: tab + " tag",
          openedClassName: "" + tab,
          contentOuterClassName: "" + (this.state.breakpoint < 3 ? "container-fluid" : "container"),
          open: this.state.currentTab === tab,
          transitionTime: 100,
          contentHiddenWhenClosed: this.state.currentTab !== tab,
          handleTriggerClick: function handleTriggerClick(accordionPosition) {
            return _this6.handleTriggerClick(accordionPosition);
          }
        },
        pane("accordion")
      );
    }
  }, {
    key: "handleTriggerClick",
    value: function handleTriggerClick(accordionPosition) {
      var _this7 = this;

      if (this.state.currentTab === accordionPosition) {
        this.setState({ currentTab: null });
      } else {
        this.setState({
          currentTab: accordionPosition
        }, function () {
          _location_service2.default.setUrlHashParameter(accordionPosition);
          setTimeout(function () {
            return _this7.scrollToTabPosition(accordionPosition);
          }, 1000);
        });
      }
    }
  }, {
    key: "checkEmptyPortfolioData",
    value: function checkEmptyPortfolioData() {
      var fund = this.props.fund;
      var historicalData = this.state.historicalData;

      var dataPointArray = _constants2.default.getPortfolioTabDataPoints().slice();
      dataPointArray.push.apply(dataPointArray, _constants2.default.getPortfolioHistoricalDataPoints());

      var totalNulls = 0;
      var properties = void 0;
      var isNull = void 0;
      for (var i = 0; (0, _ramda.and)(dataPointArray, i < (0, _ramda.length)(dataPointArray)); i++) {
        if ((0, _ramda.and)(!fund[dataPointArray[i]], !historicalData[dataPointArray[i]])) {
          totalNulls += 1;
        } else {
          properties = fund[dataPointArray[i]];
          isNull = true;
          for (var x in properties) {
            if (properties.hasOwnProperty(x)) {
              var isArrayAndHasValues = (0, _ramda.and)(_collection_utility.CollectionUtility.isArray(properties[x]), (0, _ramda.length)(properties[x]) > 0);
              var notObjectAndHasValues = (0, _ramda.and)(!_collection_utility.CollectionUtility.isArray(properties[x]), properties[x]);

              if ((0, _ramda.or)(isArrayAndHasValues, notObjectAndHasValues)) {
                isNull = false;
                break;
              }
            }
          }
          if (isNull) {
            totalNulls += 1;
          }
        }
      }

      if ((0, _ramda.or)((0, _ramda.or)(!fund.visibleData, !fund.visibleData.visibleCharts), (0, _ramda.length)(fund.visibleData.visibleCharts) < 1)) {
        totalNulls += 1;
      }

      if (totalNulls === dataPointArray.length + 1) {
        this.setState({
          hasPortfolioData: false
        });
      }
    }
  }, {
    key: "getBottomPositionOfActivePane",
    value: function getBottomPositionOfActivePane() {
      var tabs = document.getElementsByClassName("tab-pane");
      var tabElement = this.isFlatMode() ? tabs[tabs.length - 1] : this.getActiveTabElement();
      return tabElement.getBoundingClientRect().bottom;
    }
  }, {
    key: "getActiveTabElement",
    value: function getActiveTabElement() {
      return document.getElementsByClassName("tab-pane row active")[0];
    }
  }, {
    key: "hideDividendHistoryTab",
    value: function hideDividendHistoryTab() {
      if ((0, _functional_utility.doesFormattingRulesContain)("MOVE_DIVIDEND_CARD_TO_PERFORMANCE", this.props)) {
        return true;
      } else if ((0, _functional_utility3.doesVisibleDataPointContains)("DIVIDEND_HISTORY_TAB", this.props)) {
        return !!((0, _functional_utility3.isNilOrEmpty)(this.state.historicalData.dividendsDistributionHistoryList) && (0, _functional_utility3.isNilOrEmpty)(this.props.fund.annualDividendPerShare));
      } else if ((0, _functional_utility3.doesVisibleDataPointContains)("EMEA_DIVIDEND_HISTORY", this.props)) {
        return !!(0, _functional_utility3.isNilOrEmpty)(this.state.historicalData.dividendsDistributionHistoryList);
      } else if ((0, _functional_utility3.doesVisibleDataPointContains)("SHOW_DISTRIBUTION_TAB", this.props)) {
        if ((0, _functional_utility3.doesVisibleDataPointContains)("DISTRIBUTION_CARD_SHOW_ERROR_MESSAGE", this.props)) {
          return false;
        }
        return !!(0, _functional_utility3.isNilOrEmpty)(this.state.historicalData.fundDistribution);
      } else if ((0, _functional_utility3.doesVisibleDataPointContains)("DIVIDEND_CAPITAL_GAIN_TAB", this.props) || (0, _functional_utility3.doesVisibleDataPointContains)("REIT_DIVIDEND_HISTORY", this.props)) {
        return false;
      }
      return true;
    }
  }, {
    key: "hideHistoricalTab",
    value: function hideHistoricalTab() {
      var isETFHistoricalNAVMarketPrice = (0, _ramda.includes)('ETF_HISTORICAL_NAV_MARKET_PRICE', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund));
      (0, _ramda.includes)('ETF_HISTORICAL_NAV_VIIV', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund));
      var historicalNAVList = (0, _functional_utility.pathOrEmptyArray)(["historicalData", isETFHistoricalNAVMarketPrice ? "historicalETFClosingPriceList" : "historicalNAVList"], this.state);
      var showHistoryNavChart = (0, _ramda.includes)('HISTORICAL_MARKET_NAV', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleCharts"], this.props.fund)) && !(0, _functional_utility3.isNilOrEmpty)(this.state.historicalData.historicalNAVList);

      if (this.props.fund.fundTypeCode === 'REIT' && (0, _functional_utility3.isNilOrEmpty)(historicalNAVList) && !showHistoryNavChart || (0, _functional_utility3.doesVisibleDataPointContains)('HIDE_HISTORICAL_TAB', this.props)) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "showDistributorTab",
    value: function showDistributorTab() {
      if ((0, _functional_utility3.isNilOrEmpty)(this.props.fund.distributor) || !(0, _functional_utility3.doesVisibleDataPointContains)("DISTRIBUTOR_TAB", this.props)) {
        return false;
      }
      return true;
    }
  }, {
    key: "showPCFTab",
    value: function showPCFTab() {
      if (!(0, _functional_utility3.doesVisibleDataPointContains)("SHOW_PCF_TAB", this.props)) {
        return false;
      }
      return true;
    }
  }, {
    key: "renderDividendLabel",
    value: function renderDividendLabel() {
      return (0, _functional_utility3.doesVisibleDataPointContains)("REIT_DIVIDEND_HISTORY", this.props) ? _string_utility2.default.renderFormattedLabel("DISTRIBUTIONS", "pdp-distributions-tab-label") : _string_utility2.default.renderFormattedLabel("DIVIDENDS & CAPITAL GAINS", "pdp-dividends-tab-label", { role: this.props.role });
    }
  }, {
    key: "renderPerformanceTabLabel",
    value: function renderPerformanceTabLabel() {
      if ((0, _functional_utility3.doesVisibleDataPointContains)("FUND_CHARGES_PERFORMANCE_TAB", this.props)) {
        return _string_utility2.default.renderFormattedLabel("PERFORMANCE & CHARGES", "pdp-performance-charges-tab-label");
      } else {
        return _string_utility2.default.renderFormattedLabel("PERFORMANCE & FEES", "pdp-performance-tab-label", { role: this.props.role, fundType: this.props.fund.fundTypeCode });
      }
    }
  }, {
    key: "getDividendName",
    value: function getDividendName() {
      if ((0, _functional_utility3.doesVisibleDataPointContains)("SHOW_DISTRIBUTION_TAB", this.props) || (0, _functional_utility3.doesVisibleDataPointContains)("REIT_DIVIDEND_HISTORY", this.props)) {
        return "distribution";
      } else if ((0, _functional_utility3.doesVisibleDataPointContains)("DIVIDEND_CAPITAL_GAIN_TAB", this.props) || (0, _functional_utility3.doesVisibleDataPointContains)("DIVIDEND_HISTORY_TAB", this.props) || (0, _functional_utility3.doesVisibleDataPointContains)("EMEA_DIVIDEND_HISTORY", this.props)) {
        return "dividends";
      } else {
        return null;
      }
    }
  }, {
    key: "getTabProps",
    value: function getTabProps() {
      var _props = this.props,
          fund = _props.fund,
          role = _props.role;
      var _state = this.state,
          hasPortfolioData = _state.hasPortfolioData,
          scrolledTab = _state.scrolledTab;
      var currentTab = this.state.currentTab;

      var supplementalInfo = (this.props.fund.fundDocuments || {}).supplementalInformationDocuments;
      var hasFundDocumentsFromOWCS = !(0, _functional_utility3.isNilOrEmpty)(this.props.fund.fundDocuments);
      var hasAEMFundDocuments = (0, _ramda.isNil)((0, _functional_utility3.pathOrNull)(['documents', (0, _ramda.toUpper)(this.props.cusip)], this.props.content)) ? false : this.props.content.documents[(0, _ramda.toUpper)(this.props.cusip)].length > 0;
      var ISINHasFundDocuments = (0, _ramda.or)(hasFundDocumentsFromOWCS, hasAEMFundDocuments);
      if (this.props.country === 'cn') {
        ISINHasFundDocuments = !(0, _ramda.isNil)((0, _functional_utility3.pathOrNull)(['documents', (0, _ramda.toUpper)(this.props.cusip)], this.props.fund.fundDocuments));
      }
      var isSecurityLending = (0, _ramda.pathOr)(null, ["fund", "stringValueWrapper", "securityLendingFlag"], this.props) === 'Y';

      if (!(0, _ramda.isNil)(scrolledTab)) {
        currentTab = scrolledTab;
      }

      var esgData = this.props.fund.esgData || {};
      return {
        OVERVIEW: {
          shouldRender: !_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesPDPOverviewTab(), role),
          label: _string_utility2.default.renderFormattedLabel("OVERVIEW", "pdp-overview-tab-label"),
          name: "overview",
          isActive: currentTab === "overview"
        },
        PERFORMANCE_AND_FEES: {
          shouldRender: !(0, _functional_utility3.doesVisibleDataPointContains)('HIDE_PERFORMANCE_TAB', this.props),
          label: this.renderPerformanceTabLabel(),
          name: "performance",
          isActive: currentTab === 'performance'
        },
        HISTORICAL_PRICE: {
          shouldRender: !this.hideHistoricalTab() && (_collection_utility.CollectionUtility.includes(fund.visibleData.visibleCharts, 'HISTORICAL_NAV_ADVANCED') || _collection_utility.CollectionUtility.includes(fund.visibleData.visibleCharts, 'ETF_HISTORICAL_NAV_MARKET_PRICE') || _collection_utility.CollectionUtility.includes(fund.visibleData.visibleCharts, 'ETF_HISTORICAL_NAV_PRICE')),
          label: _string_utility2.default.renderFormattedLabel("HISTORICAL PRICE", "pdp-historical-price-tab-label"),
          name: "historical-price",
          isActive: currentTab === 'historical-price'
        },
        PORTFOLIO: {
          shouldRender: hasPortfolioData && !(0, _functional_utility3.doesVisibleDataPointContains)('HIDE_PORTFOLIO_TAB', this.props),
          label: _string_utility2.default.renderFormattedLabel("PORTFOLIO", "pdp-porfolio-price-tab-label"),
          name: "portfolio",
          isActive: currentTab === 'portfolio'
        },
        SECURITY_LENDING: {
          shouldRender: isSecurityLending && _collection_utility.CollectionUtility.includes(fund.visibleData.visibleFundStats, 'SECURITY_LENDING_FLAG') && !(0, _ramda.includes)("HIDE_SECURITY_LENDING_TAB", this.props.fund.visibleData.visibleDataPoints),
          label: _string_utility2.default.renderFormattedLabel("SECURITIES LENDING", "pdp-securities-lending-tab-label"),
          name: "securities-lending",
          isActive: currentTab === 'securities-lending'
        },
        PCF: {
          shouldRender: this.showPCFTab(),
          label: "申購買回清單",
          name: "pcf",
          isActive: currentTab === "pcf"
        },
        DIVIDEND: {
          shouldRender: !(0, _ramda.includes)("HIDE_DIVIDEND_TAB", fund.visibleData.visibleDataPoints) && !this.hideDividendHistoryTab(),
          label: this.renderDividendLabel(),
          name: this.getDividendName(),
          isActive: currentTab === this.getDividendName()
        },
        DISTRIBUTOR: {
          shouldRender: this.showDistributorTab(),
          label: _string_utility2.default.renderFormattedLabel("DISTRIBUTOR", "pdp-distributor-tab-label"),
          name: "distributor",
          isActive: currentTab === "distributor"
        },
        COMMENTARY: {
          shouldRender: !(0, _functional_utility3.isNilOrEmpty)(fund.shareClass.htmlCommentaries) && !_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesPDPCommentaryTab(), role) && !(0, _ramda.includes)("HIDE_COMMENTARY_TAB", this.props.fund.visibleData.visibleDataPoints),
          label: _string_utility2.default.renderFormattedLabel("COMMENTARY", "pdp-commentary-tab-label"),
          name: "commentary",
          isActive: currentTab === 'commentary'
        },
        ESG_INFORMATION: {
          shouldRender: esgData.esgIntegrationFlag && (_functional_utility2.default.isEmeaRegion(this.props.country) || _functional_utility2.default.isApacRegion(this.props.country)) && !(0, _functional_utility3.doesVisibleDataPointContains)('HIDE_ESG_INFORMATION_TAB', this.props),
          label: _string_utility2.default.renderFormattedLabel("ESG INFORMATION", "pdp-esg-information-tab-label"),
          name: "esg-information",
          isActive: currentTab === 'esg-information'
        },
        DOCUMENT: {
          shouldRender: fund.fundTypeCode === '529 Plans' && (0, _cms_utility.isAEM)(this.props) ? true : !(fund.fundTypeCode === '529 Plans' && ((0, _ramda.isNil)(supplementalInfo) || (0, _functional_utility3.isDataEmpty)(supplementalInfo))) && fund.shareClass.categoryCode !== 'Korea Shares' && (ISINHasFundDocuments || (0, _ramda.includes)("ALWAYS_SHOW_FUND_DOCUMENT_TAB", this.props.fund.visibleData.visibleDataPoints)) && !(0, _ramda.includes)("HIDE_FUND_DOCUMENT_TAB", this.props.fund.visibleData.visibleDataPoints),
          label: _string_utility2.default.renderFormattedLabel("DOCUMENTS", "pdp-documents-tab-label"),
          name: "documents",
          isActive: currentTab === 'documents'
        },
        DEFINITIONS: {
          shouldRender: (0, _functional_utility3.doesVisibleDataPointContains)("SHOW_DEFINITIONS_TAB", this.props),
          label: _string_utility2.default.renderFormattedLabel("DEFINITIONS", "pdp-definitions-tab-label"),
          name: "definitions",
          isActive: currentTab === 'definitions'
        }
      };
    }
  }, {
    key: "getTabsList",
    value: function getTabsList() {
      var fund = this.props.fund;


      var listOfAllTabs = ["OVERVIEW", "PERFORMANCE_AND_FEES", "HISTORICAL_PRICE", "PORTFOLIO", "SECURITY_LENDING", "PCF", "DIVIDEND", "DISTRIBUTOR", "COMMENTARY", "ESG_INFORMATION", "DOCUMENT", "DEFINITIONS"];

      if (fund.webDisplay === "WD_KEYFACTS") {
        listOfAllTabs = ["OVERVIEW", "PERFORMANCE_AND_FEES", "HISTORICAL_PRICE", "ESG_INFORMATION", "DOCUMENT"];
      }

      return listOfAllTabs;
    }
  }, {
    key: "renderTabContent",
    value: function renderTabContent() {
      var tabContent = {
        OVERVIEW: this.fundOverviewPane,
        PERFORMANCE_AND_FEES: this.fundPerformanceFeesPane,
        HISTORICAL_PRICE: this.fundHistoricalPricePane,
        PORTFOLIO: this.fundPortfolioPane,
        PCF: this.fundPCFPane,
        SECURITY_LENDING: this.fundSecurityLendingPane,
        DIVIDEND: this.fundDividendsCapitalGainsPane,
        DISTRIBUTOR: this.fundDistributorPane,
        COMMENTARY: this.fundCommentaryPane,
        ESG_INFORMATION: this.fundESGInformationPane,
        DOCUMENT: this.fundDocumentsPane,
        DEFINITIONS: this.fundDefinitionsPane
      };
      var tabProps = this.getTabProps();
      var listOfAllTabs = this.getTabsList();
      var markup = this.isFlatMode() ? [] : [_react2.default.createElement("div", { className: "float-clear padding-bottom-40 padding-top-5 print-hide", key: "tab-content-spacing" })];

      (0, _ramda.forEach)(function (tabName) {
        return tabProps[tabName].shouldRender && markup.push(tabContent[tabName]("tab"));
      }, listOfAllTabs);

      return markup;
    }
  }, {
    key: "renderMobileTabContent",
    value: function renderMobileTabContent() {
      var _this8 = this;

      var distributionTabArgument = this.getDividendName() || 'dividends';

      var mobileContentArguments = {
        OVERVIEW: ["overview", _string_utility2.default.renderFormattedLabel("OVERVIEW", "pdp-overview-tab-label"), this.fundOverviewPane],
        PERFORMANCE_AND_FEES: ["performance", this.renderPerformanceTabLabel(), this.fundPerformanceFeesPane],
        HISTORICAL_PRICE: ["historical-price", _string_utility2.default.renderFormattedLabel("HISTORICAL PRICE", "pdp-historical-price-tab-label"), this.fundHistoricalPricePane],
        PORTFOLIO: ["portfolio", _string_utility2.default.renderFormattedLabel("PORTFOLIO", "pdp-porfolio-price-tab-label"), this.fundPortfolioPane],
        PCF: ["pcf", _string_utility2.default.renderFormattedLabel("申購買回清單", "pdp-pcf-tab-label"), this.fundPCFPane],
        SECURITY_LENDING: ["securities-lending", _string_utility2.default.renderFormattedLabel("SECURITIES LENDING", "pdp-securities-lending-tab-label"), this.fundSecurityLendingPane],
        DIVIDEND: [distributionTabArgument, this.renderDividendLabel(), this.fundDividendsCapitalGainsPane],
        DISTRIBUTOR: ["distributor", _string_utility2.default.renderFormattedLabel("DISTRIBUTOR", "pdp-distributor-tab-label"), this.fundDistributorPane],
        COMMENTARY: ["commentary", _string_utility2.default.renderFormattedLabel("COMMENTARY", "pdp-commentary-tab-label"), this.fundCommentaryPane],
        ESG_INFORMATION: ["esg-information", _string_utility2.default.renderFormattedLabel("ESG INFORMATION", "pdp-esg-information-tab-label"), this.fundESGInformationPane],
        DOCUMENT: ["documents", _string_utility2.default.renderFormattedLabel("DOCUMENTS", "pdp-documents-tab-label"), this.fundDocumentsPane],
        DEFINITIONS: ["definitions", _string_utility2.default.renderFormattedLabel("DEFINITIONS", "pdp-definitions-tab-label"), this.fundDefinitionsPane]
      };
      var tabProps = this.getTabProps();
      var listOfAllTabs = this.getTabsList();
      var markup = [];
      (0, _ramda.forEach)(function (tabName) {
        return tabProps[tabName].shouldRender && markup.push(_this8.renderCollapsibleComponent.apply(null, mobileContentArguments[tabName]));
      }, listOfAllTabs);

      return markup;
    }
  }, {
    key: "showDynamicContentDrawer",
    value: function showDynamicContentDrawer() {
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_reactIdleTimer2.default, {
          ref: this.idleTimer,
          timeout: _constants2.default.DYNAMIC_CONTENT_IDLE_TIMEOUT,
          onAction: this.handleOnAction,
          onIdle: this.handleOnIdle
        }),
        _react2.default.createElement(_slide_drawer2.default, { drawerOpen: this.state.showSlideDrawer,
          openSlideDrawer: this.openSlideDrawer,
          recommendations: this.props.content.recommendations,
          isMobileView: this.state.breakpoint <= 3,
          dynamicContentStart: this.state.dynamicContentStart
        })
      );
    }
  }, {
    key: "trackDynamicContentDrawer",
    value: function trackDynamicContentDrawer() {
      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": 'pdp',
        "eventAction": 'dynamic cta',
        "eventLabel": 'display'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;

      if (this.missingRequiredProps()) {
        return null;
      }

      var isAppleDevice = null;
      if (_functional_utility5.default.isRunningOnAppleDevice(navigator.userAgent)) {
        isAppleDevice = 'using-apple-device';
      }

      return _react2.default.createElement(
        "div",
        { className: isAppleDevice },
        this.renderAlerts(),
        this.renderProductDetailSummary(),
        _react2.default.createElement(
          "div",
          { className: "background-soft-grey print-full-width print-white-background",
            ref: function ref(div) {
              _this9.contentWrapper = div;
            } },
          this.renderContent(),
          this.renderDisclosureSection()
        ),
        _react2.default.createElement(_tooltip_component2.default, {
          ref: this.globalTooltipRef,
          breakpoint: this.state.breakpoint
        }),
        (0, _functional_utility3.doesVisibleDataPointContains)('SHOW_DYNAMIC_CONTENT_DRAWER', this.props) && !(0, _functional_utility3.isNilOrEmpty)((0, _functional_utility3.pathOrNull)(['recommendations', 'links'], this.props.content)) ? this.showDynamicContentDrawer() : null,
        this.renderModal()
      );
    }
  }, {
    key: "openSlideDrawer",
    value: function openSlideDrawer() {
      if (!this.state.showSlideDrawer) {
        this.trackDynamicContentDrawer();
      }
      this.setState({ showSlideDrawer: !this.state.showSlideDrawer });
    }
  }, {
    key: "handleOnAction",
    value: function handleOnAction() {
      if (this.idleTimer.current.getTotalActiveTime() > _constants2.default.DYNAMIC_CONTENT_ACTIVE_TIMEOUT && !this.state.showSlideDrawer) {
        this.setState({ showSlideDrawer: true, dynamicContentStart: 0 });
        this.idleTimer.current.pause();
        this.trackDynamicContentDrawer();
      }
    }
  }, {
    key: "handleOnIdle",
    value: function handleOnIdle() {
      if (!this.state.showSlideDrawer) {
        this.setState({ showSlideDrawer: true, dynamicContentStart: 5 });
        this.trackDynamicContentDrawer();
        this.idleTimer.current.pause();
      }
    }
  }, {
    key: "renderProductDetailSummary",
    value: function renderProductDetailSummary() {
      var _this10 = this;

      return _react2.default.createElement(_pdp_summary2.default, _extends({
        ref: "summary",
        tabProps: this.getTabProps(),
        updateTabState: function updateTabState(e) {
          return _this10.updateTabState(e);
        },
        listOfAllTabs: this.getTabsList(),
        tooltip: this.globalTooltipRef.current,
        autocompleteFundData: this.state.autocompleteFundData,
        breakpoint: this.state.breakpoint,
        additionalRatingsHandler: this.additionalRatingsHandler,
        historicalData: this.state.historicalData
      }, this.props));
    }
  }, {
    key: "renderAlerts",
    value: function renderAlerts() {
      return null;
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var breakpoint = this.state.breakpoint;

      return _react2.default.createElement(
        "div",
        { id: "pdp-card-container", "data-testid": "pdp-card-container",
          className: (this.isFlatMode() ? "" : "tab-content") + " " + _functional_utility2.default.isTabOrMobileBreakpoint(breakpoint, "", "container") },
        breakpoint > 3 ? this.renderTabContent() : this.renderMobileTabContent()
      );
    }
  }, {
    key: "renderDisclosureSection",
    value: function renderDisclosureSection() {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, "HIDE_ALL_DISCLOSURE")) {
        return null;
      }
      return _react2.default.createElement(_pdp_bottom_disclosure2.default, {
        fund: this.props.fund,
        intl: this.props.intl,
        breakpoint: this.state.breakpoint,
        role: this.props.role,
        parent: this.props.parent
      });
    }
  }]);

  return ProductDetailApp;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(ProductDetailApp, { withRef: true });